export const TIMEZONES = [
  // UTC
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)', offset: '+00:00' },
  
  // Americas
  { value: 'America/New_York', label: 'Eastern Time (US & Canada)', offset: '-05:00' },
  { value: 'America/Chicago', label: 'Central Time (US & Canada)', offset: '-06:00' },
  { value: 'America/Denver', label: 'Mountain Time (US & Canada)', offset: '-07:00' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (US & Canada)', offset: '-08:00' },
  { value: 'America/Anchorage', label: 'Alaska', offset: '-09:00' },
  { value: 'Pacific/Honolulu', label: 'Hawaii', offset: '-10:00' },
  { value: 'America/Phoenix', label: 'Arizona', offset: '-07:00' },
  { value: 'America/Toronto', label: 'Toronto', offset: '-05:00' },
  { value: 'America/Vancouver', label: 'Vancouver', offset: '-08:00' },
  { value: 'America/Mexico_City', label: 'Mexico City', offset: '-06:00' },
  { value: 'America/Sao_Paulo', label: 'São Paulo', offset: '-03:00' },
  { value: 'America/Buenos_Aires', label: 'Buenos Aires', offset: '-03:00' },
  { value: 'America/Santiago', label: 'Santiago', offset: '-03:00' },
  { value: 'America/Lima', label: 'Lima', offset: '-05:00' },
  { value: 'America/Bogota', label: 'Bogotá', offset: '-05:00' },
  
  // Europe
  { value: 'Europe/London', label: 'London', offset: '+00:00' },
  { value: 'Europe/Dublin', label: 'Dublin', offset: '+00:00' },
  { value: 'Europe/Paris', label: 'Paris', offset: '+01:00' },
  { value: 'Europe/Berlin', label: 'Berlin', offset: '+01:00' },
  { value: 'Europe/Rome', label: 'Rome', offset: '+01:00' },
  { value: 'Europe/Madrid', label: 'Madrid', offset: '+01:00' },
  { value: 'Europe/Amsterdam', label: 'Amsterdam', offset: '+01:00' },
  { value: 'Europe/Brussels', label: 'Brussels', offset: '+01:00' },
  { value: 'Europe/Vienna', label: 'Vienna', offset: '+01:00' },
  { value: 'Europe/Stockholm', label: 'Stockholm', offset: '+01:00' },
  { value: 'Europe/Copenhagen', label: 'Copenhagen', offset: '+01:00' },
  { value: 'Europe/Oslo', label: 'Oslo', offset: '+01:00' },
  { value: 'Europe/Helsinki', label: 'Helsinki', offset: '+02:00' },
  { value: 'Europe/Athens', label: 'Athens', offset: '+02:00' },
  { value: 'Europe/Istanbul', label: 'Istanbul', offset: '+03:00' },
  { value: 'Europe/Moscow', label: 'Moscow', offset: '+03:00' },
  { value: 'Europe/Warsaw', label: 'Warsaw', offset: '+01:00' },
  { value: 'Europe/Prague', label: 'Prague', offset: '+01:00' },
  { value: 'Europe/Zurich', label: 'Zurich', offset: '+01:00' },
  
  // Asia
  { value: 'Asia/Dubai', label: 'Dubai', offset: '+04:00' },
  { value: 'Asia/Kolkata', label: 'Mumbai, Kolkata, New Delhi', offset: '+05:30' },
  { value: 'Asia/Karachi', label: 'Karachi', offset: '+05:00' },
  { value: 'Asia/Dhaka', label: 'Dhaka', offset: '+06:00' },
  { value: 'Asia/Bangkok', label: 'Bangkok', offset: '+07:00' },
  { value: 'Asia/Singapore', label: 'Singapore', offset: '+08:00' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong', offset: '+08:00' },
  { value: 'Asia/Shanghai', label: 'Beijing, Shanghai', offset: '+08:00' },
  { value: 'Asia/Tokyo', label: 'Tokyo', offset: '+09:00' },
  { value: 'Asia/Seoul', label: 'Seoul', offset: '+09:00' },
  { value: 'Asia/Manila', label: 'Manila', offset: '+08:00' },
  { value: 'Asia/Jakarta', label: 'Jakarta', offset: '+07:00' },
  { value: 'Asia/Kuala_Lumpur', label: 'Kuala Lumpur', offset: '+08:00' },
  { value: 'Asia/Taipei', label: 'Taipei', offset: '+08:00' },
  { value: 'Asia/Jerusalem', label: 'Jerusalem', offset: '+02:00' },
  { value: 'Asia/Riyadh', label: 'Riyadh', offset: '+03:00' },
  
  // Pacific
  { value: 'Australia/Sydney', label: 'Sydney', offset: '+11:00' },
  { value: 'Australia/Melbourne', label: 'Melbourne', offset: '+11:00' },
  { value: 'Australia/Brisbane', label: 'Brisbane', offset: '+10:00' },
  { value: 'Australia/Perth', label: 'Perth', offset: '+08:00' },
  { value: 'Australia/Adelaide', label: 'Adelaide', offset: '+10:30' },
  { value: 'Pacific/Auckland', label: 'Auckland', offset: '+13:00' },
  { value: 'Pacific/Fiji', label: 'Fiji', offset: '+12:00' },
  { value: 'Pacific/Guam', label: 'Guam', offset: '+10:00' },
  
  // Africa
  { value: 'Africa/Cairo', label: 'Cairo', offset: '+02:00' },
  { value: 'Africa/Johannesburg', label: 'Johannesburg', offset: '+02:00' },
  { value: 'Africa/Lagos', label: 'Lagos', offset: '+01:00' },
  { value: 'Africa/Nairobi', label: 'Nairobi', offset: '+03:00' },
  { value: 'Africa/Casablanca', label: 'Casablanca', offset: '+01:00' },
];
